import axios from 'axios'
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig
} from 'axios'
import { useUserStore } from '@/stores/user'

const baseURL = import.meta.env.VITE_APP_API_URL
const apiClient: AxiosInstance = axios.create({
  baseURL: baseURL
})

// İstek interceptor'u: Her istek gönderilmeden önce çalışır
apiClient.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const store = useUserStore()
    // Initialize headers if not already set
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + store.getTokens.value.accessToken
    }

    // Apply any required headers here, for example, an Authorization token
    // const token: string = 'your_access_token';
    // config.headers.Authorization = `Bearer ${token}`;

    // Casting to the internal Axios type may be necessary if TypeScript errors persist
    return config as unknown as InternalAxiosRequestConfig<any>
  },
  (error: AxiosError) => {
    console.log('Request error:', error)
    return Promise.reject(error)
  }
)

// Yanıt interceptor'u: Her yanıt geldikten sonra çalışır
apiClient.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    // Yanıt başarılı olduğunda burası çalışır
    console.log('Response received:', response)
    return response
  },
  (error: AxiosError): Promise<AxiosError> => {
    // Yanıt hatası işleniyor
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.clear()
      window.location.href = '/'
    }
    console.log('Response error:', error)
    return Promise.reject(error)
  }
)

export default apiClient
